import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Typography } from "@mui/material";
import ResponsiveDialog from "../../../Component/ResponsiveDialog";
import { Link, useSearchParams } from "react-router-dom";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {useSelector} from "react-redux"
import {
  ArrowBack,
  ArrowCircleDown,
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import TechnicalSpecAttrModal from "./TechSpecAttrModal";
import CloneTechSpec from "./CloneTechSpec";
import { decode } from "../../../Component/JWT/Formatt";


const TechnicalSpecAttr = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [cloneOption,setCloneOption]=useState(false)
  const code = searchParams.get("code")
  const name = searchParams.get("name")
  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const id=decode(searchParams.get("id"))
    const link = masterAPI["techSpecAttr"].getByTechSpecId;
   await axiosPrivate
      .get(`${link}/${id}`)
      .then((res) => {
        console.log(res.data, "technicalSpecAttributes result");
        setData(res.data.result);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "technicalSpecAttributes");
        setIsLoading(false);
        setData([])
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleDelete = async(id) => {
    const deleteLink = masterAPI["techSpecAttr"].delete;
   await axiosPrivate
      .delete(`${deleteLink}/${id}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "delete technicalSpecAttributes");
      });
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{width:color.checkBoxWidth }}>
          <Checkbox
            // icon={<RadioButtonUncheckedOutlined />}
            // checkedIcon={<CheckCircle />}
          />
          </Box>
        );
      },
    },
 
    {
      Header: "Attribute Name",
      accessor: "attributeName",
      // disableFilters: true,
    },
    {
      Header: "Attribute Value",
      accessor: "attributeValueType",
      // Cell: ({ row }) => {
      //   const { attributeTextValue, attributeNumericValue, attributeDateValue } = row.original;
      //   const values = [];
  
      //   if (attributeTextValue !== " " && attributeTextValue !== "") values.push(attributeTextValue);
      //   if (attributeNumericValue !== 0) values.push(attributeNumericValue);
      //   if (attributeDateValue) values.push(attributeDateValue);
  
      //   return values.join(', ') || null;  // Join values with a comma or show 'N/A' if all are empty
      // },
    },
    // {
    //   Header: "Attribute Text",
    //   accessor: "attributeTextValue",
    // },
    // {
    //   Header: "Attribute Date",
    //   accessor: "attributeDateValue",
    // },
   

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
            <IconButton disabled={!actionsAllow.edit}>
              <DeleteOutline
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleCloneButton=()=>{
   setCloneOption(true)
  }

  const handleCloseClone=()=>{
    setCloneOption(false)
  }

  return (
    <>
      <Box  sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%",
             // mb: "1rem",
              gap: "1rem",
            }}>
        <Link to="/masters/technicalSpecification"><IconButton><ArrowBack/></IconButton></Link>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            // mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI['techSpecAttr'].title} - {code} - {name}
        </Typography>
      </Box>
     
        <TableContainer
          columns={columns}
          data={data}
          buttonNew={handleButtonNew}
          loading={isLoading}
          buttonDisable={!actionsAllow.edit}
          clone={true}
          handleCloneButton={handleCloneButton}
        />
   

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        PaperProps={{
          sx: {
            maxWidth: '70vw',
            width:"65vw"
          },
        }}
        children={
          <TechnicalSpecAttrModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
      <ResponsiveDialog
        open={cloneOption}
        onClose={handleCloseClone}
        PaperProps={{
          sx: {
            maxWidth: '70vw',
            width:"65vw"
          },
        }}
        children={
          <CloneTechSpec
            handleCloseClick={handleCloseClone}
            
          />
        }
      />
    </>
  );
};

export default TechnicalSpecAttr;
